import React, { createContext, useContext, useState, useCallback } from "react";


interface settingsType {
  visable_keys: boolean;
  enableshortcuts: boolean;

}
interface ModalContextType {
  modalStack: string[];
  pushModal: (id: string) => void;
  popModal: (id: string) => void;
  getTopModal: () => string | null;
  clearModalStack: () => void;
  setCurrentTitle: (Title: string) => void;
  tableStack: string[];
  pushKey: (Key: string) => void;
  popKey: () => void;
  getTopKey: () => string | null;
  settings: settingsType;
  setSettings: React.Dispatch<React.SetStateAction<settingsType>>;

}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [modalStack, setModalStack] = useState<string[]>([]);
  const [CurrentTitle, SetCurrentTitle] = useState<string>("");
  const [tableStack, setTableStack] = useState<string[]>([]);
  const [settings, setSettings] = useState({
    visable_keys: false,
    enableshortcuts: false,
  });

  const pushModal = useCallback((id: string) => {
    // debugger;
    setModalStack((prev) => {
      let arr = [...prev];
      // Remove the id if it's already present
      arr = arr.filter((item) => item !== id);
      // Add the id to the top of the array
      arr.push(id);
      return arr;
    });
  }, []);

  const popModal = useCallback((id: string) => {
    setModalStack((prev) => prev.filter((modalId) => modalId !== id));
  }, []);

  // const popModal = useCallback((id: string) => {
  //   setModalStack((prev) => prev.slice(0, -1));
  // }, []);

  const clearModalStack = useCallback(() => {
    setModalStack([]);
  }, []);

  const setCurrentTitle = useCallback((Title: string) => {
    SetCurrentTitle(Title);
  }, []);
  const getTopModal = useCallback(() => {
    return modalStack.length > 0 ? modalStack[modalStack.length - 1] : CurrentTitle;
  }, [modalStack]);

  const pushKey = useCallback((Key: string) => {

    setModalStack((prev) => {
      let arr = [...prev];
      // Remove the Key if it's already present
      arr = arr.filter((item) => item !== Key);
      // Add the Key to the top of the array
      arr.push(Key);
      return arr;
    });
  }, []);
  const popKey = useCallback(() => {
    setTableStack((prev) => prev.slice(0, -1));
  }, []);
  const getTopKey = useCallback(() => {

    return modalStack.length > 0 ? modalStack[modalStack.length - 1] : CurrentTitle;
  }, [modalStack]);
  // console.log(modalStack, getTopModal(), "modalStackmodalStackmodalStackmodalStack");

  return (
    <ModalContext.Provider
      value={{
        modalStack,
        tableStack,
        pushModal,
        popModal,
        setCurrentTitle,
        clearModalStack,
        getTopModal,
        pushKey,
        popKey,
        getTopKey,
        settings,
        setSettings,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModalContext must be used within a ModalProvider");
  }
  return context;
};
